// extracted by mini-css-extract-plugin
module.exports = {"withoutSpacing":"WithoutSpacing_withoutSpacing__5iGRz"};